import React, { useEffect, useState } from 'react'
import { IconButton, InputAdornment, makeStyles } from '@material-ui/core'
import { Grid } from '@material-ui/core'
import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import i18n from '../language/localization'
import { withNamespaces } from 'react-i18next'
import {
  forgotPasswordResetPassword,
  forgotPasswordSendOtp,
  forgotPasswordVerifcationOtp
} from 'api/forgot-password'
import BasicModal from 'components/modal/BasicModal'
import { useHistory } from 'react-router-dom'
import OtpInput from 'react-otp-input'
import { Visibility, VisibilityOff } from 'components/Icons'
import { loginUseStyles } from './Login.style'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace'

const countDownOtpInterval = 30

const Header = ({ title, onBack }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        width: '100%'
      }}
    >
      {onBack && (
        <IconButton size='small' style={{ marginLeft: -12, marginRight: 4 }}>
          <KeyboardBackspaceIcon style={{ width: '25px', color: 'black' }} onClick={onBack} />
        </IconButton>
      )}
      <h1 className='mb-0' style={{ color: 'black', fontSize: 24 }}>
        {title}
      </h1>
    </div>
  )
}

const ForgotPassword = ({ t }) => {
  const history = useHistory()

  const [errorMessages, setErrorMessages] = useState(undefined)
  const [successReset, setSuccessReset] = useState(undefined)

  const [stepType, setStepType] = useState('sendOtp')
  const ThemeColor = JSON.parse(localStorage.getItem('themeColor'))
  const theme = createTheme({
    palette: {
      primary: {
        main: ThemeColor ? ThemeColor : '#FFFFFF'
      }
    }
  })

  const useStyles = makeStyles(() => ({
    root: {
      flexGrow: 1,
      // width: '100%',
      backgroundColor: 'white'
      // height: '100vh'
    },
    passInput: {
      '& .MuiButtonBase-root': {
        padding: '0'
      },
      '& .MuiSvgIcon-root': {
        margin: '0 !important'
      }
    }
  }))
  const loginStyles = loginUseStyles()
  const classes = useStyles()

  const [countDownOtp, setCountDownOtp] = useState(0)

  const [email, setEmail] = useState('')
  const [otp, setOtp] = useState('')
  const [code, setCode] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)

  const submitSendOtp = async () => {
    const data = {
      email: email
    }

    forgotPasswordSendOtp(data)
      .then(() => {
        setStepType('verifyOtp')
        setTimeout(() => {
          setCountDownOtp(countDownOtpInterval)
        }, 200)
      })
      .catch(error => {
        setErrorMessages(error?.response?.data?.message || error.message)
      })
  }

  const submitVerifyOtp = async () => {
    const data = {
      email: email,
      otp: otp
    }

    forgotPasswordVerifcationOtp(data)
      .then(response => {
        setStepType('reset')
        setCode(response.data.data.code)
      })
      .catch(error => {
        setErrorMessages(error?.response?.data?.message || error.message)
      })
  }

  const submitReset = async () => {
    const data = {
      email: email,
      code: code,
      new_password: password,
      new_password_confirmation: confirmPassword
    }

    forgotPasswordResetPassword(data)
      .then(response => {
        setSuccessReset(response.data.message)
      })
      .catch(error => {
        setErrorMessages(error?.response?.data?.message || error.message)
      })
  }

  useEffect(() => {
    i18n.changeLanguage(JSON.parse(localStorage.getItem('Language')))
  }, [])

  useEffect(() => {
    if (countDownOtp > 0 && stepType === 'verifyOtp') {
      const interval = setInterval(() => {
        setCountDownOtp(countDownOtp - 1)
      }, 1000)

      return () => clearInterval(interval)
    }
  }, [countDownOtp])

  return (
    <ThemeProvider theme={theme}>
      <div className={loginStyles.body}>
        <div className={loginStyles.boxContainer}>
          {stepType === 'sendOtp' ? (
            <div>
              <Header title={t('forgot_password')} onBack={() => history.push('/login')} />
              <div className='d-flex align-items-center justify-content-center'>
                <ValidatorForm
                  className='w-100'
                  onSubmit={submitSendOtp}
                  onError={errors => console.log(errors)}
                >
                  <Grid item xs={12} style={{ margin: '16px 0' }}>
                    <label htmlFor='email'>Email</label>
                    <TextValidator
                      id='email'
                      fullWidth={true}
                      onChange={e => setEmail(e.target.value)}
                      name='email'
                      value={email}
                      variant='outlined'
                      size='small'
                      validators={['required']}
                      errorMessages={['this field is required', 'email is not valid']}
                    />
                  </Grid>
                  <div className='finish' style={{ marginRight: 0, marginLeft: 0 }}>
                    <button
                      className='finish-btn text-uppercase'
                      style={{ backgroundColor: ThemeColor ? ThemeColor : '#FFFFFF' }}
                    >
                      {t('continue')}
                    </button>
                  </div>
                </ValidatorForm>
              </div>
            </div>
          ) : stepType === 'verifyOtp' ? (
            <div>
              <Header title={t('verify_otp')} onBack={() => setStepType('sendOtp')} />
              <div className='d-flex align-items-center justify-content-center'>
                <ValidatorForm
                  className='w-100'
                  onSubmit={submitVerifyOtp}
                  onError={errors => console.log(errors)}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      textAlign: 'center'
                    }}
                  >
                    <h5>{t('title_otp')}</h5>
                    <p>
                      {t('subtitle_otp')} {email}
                    </p>

                    <div
                      style={{
                        marginTop: '48px',
                        marginBottom: '48px'
                      }}
                    >
                      <OtpInput
                        value={otp}
                        onChange={setOtp}
                        numInputs={6}
                        renderInput={props => <input {...props} />}
                        inputStyle={{
                          width: '32px',
                          height: '32px',
                          fontSize: '20px',
                          margin: '0 6px',
                          borderRadius: 'none',
                          border: 'none',
                          borderBottom: '1px solid #000000'
                        }}
                      />
                    </div>

                    <div>
                      <button
                        type='submit'
                        className='finish-btn mt-3 text-uppercase btn'
                        style={{ backgroundColor: ThemeColor ? ThemeColor : '#FFFFFF' }}
                      >
                        {t('verify')}
                      </button>
                      <button
                        type='button'
                        className='finish-btn mt-3 text-uppercase btn'
                        style={{ backgroundColor: ThemeColor ? ThemeColor : '#FFFFFF' }}
                        disabled={countDownOtp > 0}
                        onClick={() => {
                          setCountDownOtp(countDownOtpInterval)
                          submitSendOtp()
                        }}
                      >
                        {t('resend')} {countDownOtp > 0 ? `(${countDownOtp})` : ''}
                      </button>
                    </div>
                  </div>
                </ValidatorForm>
              </div>
            </div>
          ) : (
            <div>
              <Header title={t('enter_new_passwrod')} />
              <div className='d-flex align-items-center justify-content-center'>
                <ValidatorForm
                  className='w-100'
                  onSubmit={submitReset}
                  onError={errors => console.log(errors)}
                >
                  <Grid item xs={12} style={{ margin: '15px 0' }}>
                    <label>{t('new_password')}</label>
                    <TextValidator
                      className={classes.passInput}
                      fullWidth={true}
                      onChange={e => setPassword(e.target.value)}
                      variant='outlined'
                      size='small'
                      name='password'
                      type={showPassword ? 'text' : 'password'}
                      validators={['required']}
                      errorMessages={['Please enter password']}
                      value={password}
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position='start' classes={{ positionStart: '0px' }}>
                            <IconButton
                              onClick={() => setShowPassword(!showPassword)}
                              style={{
                                color: ThemeColor ? ThemeColor : '#FFFFFF'
                              }}
                            >
                              {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} style={{ margin: '15px 0' }}>
                    <label>{t('retype_new_password')}</label>
                    <TextValidator
                      className={classes.passInput}
                      fullWidth={true}
                      onChange={e => setConfirmPassword(e.target.value)}
                      variant='outlined'
                      size='small'
                      name='confirmPassword'
                      type={showPassword ? 'text' : 'password'}
                      validators={['required']}
                      errorMessages={['Please enter password']}
                      value={confirmPassword}
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position='start' classes={{ positionStart: '0px' }}>
                            <IconButton
                              onClick={() => setShowPassword(!showPassword)}
                              style={{
                                color: ThemeColor ? ThemeColor : '#FFFFFF'
                              }}
                            >
                              {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                  </Grid>
                  <div className='finish' style={{ marginRight: 0, marginLeft: 0 }}>
                    <button
                      className='finish-btn mt-3 text-uppercase'
                      style={{ backgroundColor: ThemeColor ? ThemeColor : '#FFFFFF' }}
                    >
                      {t('continue')}
                    </button>
                  </div>
                </ValidatorForm>
              </div>
            </div>
          )}
          {errorMessages ? (
            <BasicModal
              isOpen={true}
              title='Error Forgot Password'
              content={errorMessages}
              onClose={() => setErrorMessages(undefined)}
            />
          ) : null}

          {successReset ? (
            <BasicModal
              isOpen={true}
              title='Success Reset Password'
              content={successReset}
              onClose={() => {
                setSuccessReset(undefined)

                history.push('/login')
              }}
            />
          ) : null}
        </div>
      </div>
    </ThemeProvider>
  )
}
export default withNamespaces()(ForgotPassword)
